import { render, staticRenderFns } from "./kertaskerja.vue?vue&type=template&id=3b96498c"
import script from "./kertaskerja.vue?vue&type=script&lang=js"
export * from "./kertaskerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports